module.exports = __webpack_public_path__ + "static/media/digital-signage-img1.463748f7.jpg";